import { createContext } from 'react';
const FinancialInstitutionContext = createContext();
export default FinancialInstitutionContext;
